//const BASE_URL = 'http://192.168.29.113:8080';
const BASE_URL = 'https://jobs.sssoffice.in';


export const API = {
  getAllUsers: `${BASE_URL}/form/allUserList`,
  getExcelDownload: (flag) => `${BASE_URL}/admin/downloadExcel/${flag}`,
  getUserById: (id, flag) => `${BASE_URL}/form/getUserById/${id}?flag=${flag}`,
  submitUserData: `${BASE_URL}/form/submitForm`,
  getFormCounts: `${BASE_URL}/form/getFormCounts`,
  getFormStatus: `${BASE_URL}/form/getFormStatusFlag`,
  getFormSettings: `${BASE_URL}/form/getFormSettings`,
};

export const LoginAPI = {
  adminLogin: `${BASE_URL}/admin/adminLogin`,
}


export const CountAPI = {
  getFormCounts: `${BASE_URL}/form/getFormCounts`,
}

export const FormAPI = {
  getFormById: (id, flag) => `${BASE_URL}/form/getFormById/${id}/${flag}`,
  checkDuplicateFields: () => `${BASE_URL}/form/checkDuplicateFeilds`
};

/*

get all user data = http://192.168.29.113:8080/form/allUserList

get user by id = http://192.168.29.113:8080/form/getUserById/:id

get user by flag = http://192.168.29.113:8080/form/getUserById/:id?flag= 1 or 2

submit user data = http://192.168.29.113:8080/form/submitForm

get Form Status Flag = http://192.168.29.113:8080/form/getFormStatusFlag

{
    "flag": 1,
    "message": "Form is open."
}


get date form setting =  http://192.168.29.113:8080/form/getFormSettings

{
        "flag": 1,
        "last_name": "patil",
        "name": "rohit",
        "father_name": "y",
        "address": "654 MG Road",
        "date_of_birth": "2001-07-10",
        "mobile": "7665432319",
        "email": "7sdmulani@gmail.com",
        "aadhar_no": "911991111111",
        "tenth_per": 78,
        "twelth_per": 72,
        "choose_degree": "B.Com",
        "obtained_grade": "AB+",
        "typewriting_marathi_score": 48,
        "typewriting_english_score": 52,
        "mscit_per": 80,
        "cast": "ST",
        "cast_certificate": false,
        "cast_cert_no": null,
        "date_cast_cert": null,
        "cast_cert_issuing_village": null,
        "cast_validity_certificate": false,
        "cast_validity_cert_no": null,
        "date_cast_validity_cert": null,
        "cast_validity_cert_issuing_village": null,
        "ews": true,
        "ews_cert_date": "2021-12-01",
        "ews_cert_village": "Miraj",
        "ews_cert_validity_year": "2022",
        "sebc_cert": true,
        "sebc_cert_date": "2022-01-15",
        "sebc_cert_village": "Sangli",
        "non_creamy_validity_year": "2023"
    }

update user data = http://192.168.29.113:8080/form/updateForm/:id

delete user data = http://192.168.29.113:8080/form/deleteForm/:id

get Form Count = http://192.168.29.113:8080/form/getFormCounts

admin login = http://192.168.29.113:8080/admin/adminLogin

        {
           "loginId": "admin",
           "password": "admin"
            
        }

const customerMadeValue = customerMade === "Yes" ? 1 : customerMade === "No" ? 2 : 1;

download Exel = http://192.168.29.113:8080/admin/downloadExcel/:flag

<a href="http://192.168.29.113:8080/admin/downloadExcel/1" download>
    Download Clerk Excel
</a>

<a href="http://192.168.29.113:8080/admin/downloadExcel/2" download>
    Download Assistant Excel
</a>

get FormBy Id = http://localhost:8080/form/getFormById/:id/:flag (1,2)

check Duplicate Feilds =   http://192.168.29.113:8080/form/checkDuplicateFeilds

{
    "email": "sohebmulani09@gmail.com",
   "aadhar_no": "073311311111",
   "mobile": "0039990111",
   "flag": 1
}
import React, { useState, useEffect } from "react";
import "./HomePage.css";
import { useNavigate } from "react-router-dom";
import Footer from "../admin/Footer";
import Header from "../admin/Header";

const HomePage = () => {
  const [agreed, setAgreed] = useState(false);
  const [formOpen, setFormOpen] = useState(true); // default to true
  const navigate = useNavigate();

  const handleCheckboxChange = (e) => {
    setAgreed(e.target.checked);
  };

  /*useEffect(() => {
    // Replace with your actual API endpoint
    fetch("https://your-api.com/form-status")
      .then((res) => res.json())
      .then((data) => {
        // Assume API returns { isFormOpen: true/false }
        setFormOpen(data.isFormOpen);
      })
      .catch((error) => {
        console.error("API Error:", error);
        // Optional: default to closed in case of error
        setFormOpen(false);
      });
  }, []);

  useEffect(() => {
    // Replace this with your actual API URL
    fetch("https://your-api.com/form-status")
      .then((res) => res.json())
      .then((data) => {
        // Assuming data.flag is either 1 or 2
        if (data.flag === 1) {
          setFormOpen(true);  // Form is open
        } else if (data.flag === 2) {
          setFormOpen(false); // Form is closed
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // Optional: default to closed in case of error
        setFormOpen(false);
      });
  }, []);  

  return (
    <>
      <Header />
      <div className="home-container">
        <div className="guidelines-box">
          {!formOpen ? (
            <h2 className="home-title" style={{ color: "red" }}>
              नोंदणी करण्याची अंतिम तारीख संपली आहे.धन्यवाद!.
            </h2>
          ) : (
            <>
              <h1 className="home-title">सूचना</h1>
              <ul>
                <li>इच्छुक उमेदवारांनी आपली परिपूर्ण माहिती १६.०४.२०२५ ते २२.०४.२०२५ अखेर नोंदवावी.</li>
                <li>सदरची नोंदणी २२.०४.२०२५ रोजी रात्री १२.०० वाजता बंद होईल. </li>
                <li>सर्व आकडेवारी इंग्रजीत भरणेची आहे. </li>
                <li>आपण भरलेल्या अर्जाची प्रत नोंदणी केलेल्या ईमेल ला पाठवण्यात येईल.</li>
              </ul>

              <div className="checkbox-section">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={agreed}
                    onChange={handleCheckboxChange}
                  />
                  मी वरील माहिती वाचली आहे.
                </label>
              </div>

              {agreed && (
                <div className="post-selection">
                  <h2 className="home-title">पोस्ट निवडा</h2>
                  <div className="card-container">
                    <div
                      className="position-card"
                      onClick={() => {
                        sessionStorage.setItem("selectedPost", "1");
                        navigate("/clerk-form");
                      }}
                    >
                      <h4>कनिष्ठ लिपिक पदासाठी अर्ज</h4>
                    </div>

                    <div
                      className="position-card"
                      onClick={() => {
                        sessionStorage.setItem("selectedPost", "2");
                        navigate("/assistance-form");
                      }}
                    >
                      <h4>प्रयोगशाळा सहाय्यक पदासाठी अर्ज</h4>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default HomePage;

*/